import React from 'react';
import '../styles/modules/_social-links.scss';

export default function SocialLinks() {
   return (
      <div className="social-links">
         <a href="/">Instagram</a>
         <a href="/">Facebook</a>
         <a href="/">Linkedin</a>
      </div>
   )
}